import store from "@shared/scripts/utils/store";
import { openModalWithCb } from "@shared/scripts/actions/modal";

const switchBaseModal = () => {
  const $login = $(".sidebar-user__logout");

  const openFn = (cb = () => {}) => {
    store.dispatch(
      openModalWithCb("signin", () => {
        console.log("状态更改完成");
        cb();
        // 动画
        setTimeout(() => {
          console.log("visible change");
          $(".js-signin-modal").toggleClass("is-visible");
        });
      })
    );
  };

  const wxLogin = () => {
    let url = "";
    const mdetect = require("mdetect");

    if (mdetect.isWechat()) {
      url = `${window.location.origin}/auth/wechatservice`;
    } else {
      url = `https://open.weixin.qq.com/connect/qrconnect?appid=wx8c9a93acb12e2b2d&scope=snsapi_login&redirect_uri=${window.location.origin}/auth/wechat/callback&state=&login_type=jssdk&self_redirect=default`;
    }
    window.location.href = url;
  };

  if ($login.length === 0) {
    if (window.popupLogin) {
      openFn();
    }
  } else {
    if (window.currentUser && !window.currentUser.mobile_verified) {
      openFn();
    }
  }

  // const $window = $(window);
  const $sidebar = $(".js-sidebar");
  const $sidebarLayer = $(".sidebar__layer");

  const sidebarClose = () => {
    if ($sidebar.hasClass("is-visible")) {
      $sidebar.removeClass("is-visible");
      $(".js-switch-siderbar").removeClass("is-active");
    }

    if ($sidebarLayer.hasClass("is-visible")) {
      $sidebarLayer.removeClass("is-visible");
      $(".js-switch-siderbar").removeClass("is-active");
    }
  };

  // sidebar
  $(".js-switch-siderbar").on("click", function(e) {
    e.stopPropagation();
    $sidebar.toggleClass("is-visible");
    $sidebarLayer.toggleClass("is-visible");
    $(this).toggleClass("is-active");
  });

  $sidebarLayer.on("click", function(e) {
    e.stopPropagation();
    sidebarClose();
  });

  // search modal
  $(".js-switch-search").on("click", e => {
    e.stopPropagation();
    $(".js-search").toggleClass("is-visible");
    sidebarClose();
  });

  // signin modal
  $(".js-switch-sign").on("click", e => {
    // console.log("触发登录");
    e.preventDefault();
    sidebarClose();
    if (
      $(".js-signin-modal")[0] &&
      $(".js-signin-modal")[0].className.includes("is-visible") &&
      window.popupLogin
    ) {
      return false;
    }
    // 判断是否微信浏览器
    const useragent = navigator.userAgent.toLowerCase();
    const isWx = /MicroMessenger/i.test(useragent);
    if (isWx) {
      wxLogin();
    } else {
      openFn();
    }
  });

  // forget modal
  $(".js-forget-mask").on("click", e => {
    e.stopPropagation();
    $(".js-forget-modal").removeClass("is-visible");
  });
};

export default switchBaseModal;
